import { FunctionComponent, ReactNode } from "react";

import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import { applicationConfig } from "../environmentConfiguration";
import { clearAuthenticatedUserContext, setAuthenticatedUserContext } from "../utils/appInsights";
import { msalConfig } from "./auth-config";
import { TokenRefreshManager } from "./TokenRefreshManager";

interface IAuthProviderProps {
  children: ReactNode;
}

const msalInstance = new PublicClientApplication(msalConfig);

// Listen for sign-in, sign-out, and initialize events and set active account and application insights context
msalInstance.addEventCallback((event: EventMessage) => {
  const authenticationResult = event.payload as AuthenticationResult;
  const account = authenticationResult?.account;

  if (event.eventType === EventType.LOGIN_SUCCESS && account) {
    msalInstance.setActiveAccount(account);
    setAuthenticatedUserContext(account.localAccountId);
  } else if (event.eventType === EventType.LOGOUT_START) {
    clearAuthenticatedUserContext();
  } else if (event.eventType === EventType.INITIALIZE_END) {
    const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

    if (account) {
      msalInstance.setActiveAccount(account);
      setAuthenticatedUserContext(account.localAccountId);
    } else {
      clearAuthenticatedUserContext();
    }
  }
});

TokenRefreshManager.initialize(msalInstance, {
  apiPermissionScopes: applicationConfig.permissionScopes,
});

export const AuthProvider: FunctionComponent<IAuthProviderProps> = ({ children }: IAuthProviderProps) => (
  <MsalProvider instance={msalInstance}>{children}</MsalProvider>
);
